import { logger } from '@belong/logging/logger';
import { getEnvVars } from './getEnvVars';

export const createChatSession = (
  chatDetails: connect.ChatDetailsInput
): ReturnType<typeof connect.ChatSession.create> => {
  const region = getEnvVars().aws?.region;

  if (!region) {
    logger.error('Config not found: Chat AWS Region');
    throw new Error();
  }
  // Enable read receipts via global configurations
  connect.ChatSession.setGlobalConfig({});

  return connect.ChatSession.create({
    chatDetails,
    type: 'CUSTOMER',
    options: { region }
  });
};
